import { AssetCustomField } from '@assetaccountant/api/models/asset-custom-field';

export interface AssetRegime {
  depreciationMethodId: number;
  depreciationMethodCode?: string;
  rate: number | null;
  life: number | null;
  taxableUse: number | null;
  regimeId: number;
  regimeName: string;
  effectiveDate: string;
  notes: string | null;
  settings: AssetRegimeSetting[];
  depreciationRules: Array<{ id: number }>;
}

export class AssetRegimeSetting {
  settingType: number;
  value: boolean;
}

export class Asset {
  public static lockingEvents: string[] = ['Sale', 'WriteOff', 'TransferToPool'];

  id = 0;
  groupId: number;
  name: string;
  code: string;
  description: string;
  fullDescription: string;
  purchaseDate: string;
  firstUseDate: string | null;
  capitalGainsTaxDate: string | null;
  purchasePrice: number;
  regimes: AssetRegime[] = [];
  openingBalanceDate: string | null;
  customFields?: AssetCustomField[] | null;
}
